import { Types } from './types'

const initialState = {
    dataComment: {
        filter: {},
        rows: []
    },
    currentRecord: null
}
const commentReducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_COMMENT:
            return {
                ...newState,
                dataComment: action.payload
            }
        case Types.SET_RECORD:
            return {
                ...newState,
                currentRecord: action.payload
            }
        default:
            return { ...newState }
    }
}
export default commentReducer
